export const POLYLINE_TOOL_ID = "polyline";

const drawPolyline = ({ ctx, points }) => {
  if (!points || points.length < 2) {
    return;
  }

  ctx.beginPath();
  ctx.moveTo(points[0].x, points[0].y);
  for (let i = 1; i < points.length; i += 1) {
    ctx.lineTo(points[i].x, points[i].y);
  }
  ctx.stroke();
};

export const polylineToolConfig = {
  id: POLYLINE_TOOL_ID,
  usesPreview: true,
  cursor: "crosshair",
  onStart: ({ lastPointRef }) => {
    lastPointRef.current = {
      ...lastPointRef.current,
      polylinePoints: [
        { x: lastPointRef.current.x, y: lastPointRef.current.y },
      ],
    };
    return true;
  },
  onMove: ({ ctx, lastPointRef, nextPoint }) => {
    const points = lastPointRef.current.polylinePoints || [];
    const nextPoints = [...points, nextPoint];
    drawPolyline({ ctx, points: nextPoints });
  },
  onEnd: ({ ctx, lastPointRef, endPoint }) => {
    const points = lastPointRef.current.polylinePoints || [];
    const finalPoints = [...points, endPoint];
    drawPolyline({ ctx, points: finalPoints });
    lastPointRef.current = {
      ...lastPointRef.current,
      polylinePoints: undefined,
    };
  },
};

const PolylineToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === POLYLINE_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(POLYLINE_TOOL_ID)}
      title="Polyline"
      aria-label="Polyline"
    >
      ╱╲
    </button>
  );
};

export default PolylineToolButton;
